module.exports = __webpack_public_path__ + "static/Planet_2-1cd1fe2ad994a81743d93fa797c67987.png";